/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:a178f3ae-bb9a-4917-96c6-62501fdcc01e",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_fxSEKRAeN",
    "aws_user_pools_web_client_id": "3qqi3coekja5kfr1lvoj661ucf",
    "oauth": {}
};


export default awsmobile;
